import { render, staticRenderFns } from "./ShowNotice.vue?vue&type=template&id=1bf78ff6&"
import script from "./ShowNotice.vue?vue&type=script&lang=js&"
export * from "./ShowNotice.vue?vue&type=script&lang=js&"
import style0 from "./ShowNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf78ff6')) {
      api.createRecord('1bf78ff6', component.options)
    } else {
      api.reload('1bf78ff6', component.options)
    }
    module.hot.accept("./ShowNotice.vue?vue&type=template&id=1bf78ff6&", function () {
      api.rerender('1bf78ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/ShowNotice.vue"
export default component.exports